function formatMetricValues(value: number) {
  if (!value || isNaN(value)) return '0'
  const formattedValue = Number(value.toFixed(0))
  return new Intl.NumberFormat().format(formattedValue)
}

export default formatMetricValues
